import {
  isFacetPageType,
  isLocationPageType
} from '@/domain/useCases/pageTypeCheck'
import type { FAQ, PageType, LocationPart } from '@/types/models'
import { isNonEmptyArray, isNull } from '@/utils/checks'
import { LOCATION_SUD_TERM_ID } from '@/domain/FAQs/constants'

export const filterFaqsByLocation = ({
  customFAQs = [],
  locationParts,
  pageType
}: {
  customFAQs: FAQ[] | []
  location: string
  locationParts: LocationPart[]
  pageType?: PageType
}): FAQ[] => {
  if (!isNonEmptyArray(customFAQs) || !pageType) {
    return []
  }
  if (isLocationPageType(pageType)) {
    const locationIds = locationParts.map((part) => part.id)

    const customLocationFAQs = customFAQs.filter((faq: FAQ) =>
      locationIds.some((id) => faq?.locationId === id)
    )

    const customSUDFAQs = filterByLocationParts({
      locationParts,
      termId: LOCATION_SUD_TERM_ID,
      faq: customFAQs
    })

    const uniqueFAQs = [...customLocationFAQs, ...customSUDFAQs].reduce(
      (acc, faq) => {
        const faqAlreadyAdded = acc.some((item) => item.id === faq.id)
        if (!faqAlreadyAdded) {
          acc.push(faq)
        }
        return acc
      },
      [] as FAQ[]
    )
    return uniqueFAQs
  }
  if (isFacetPageType(pageType)) {
    return Array.from([...customFAQs]).reverse()
  }
  return customFAQs.filter((faq: FAQ) => !faq.location)
}

export const filterByLocationParts = ({
  locationParts,
  termId,
  faq
}: {
  locationParts: LocationPart[]
  termId: number
  faq: FAQ[]
}): FAQ[] | [] => {
  if (!isNonEmptyArray(locationParts) || !termId || !isNonEmptyArray(faq)) {
    return []
  }
  return faq.filter(
    (faq) =>
      faq.termId === termId &&
      (isNull(faq.locationId) ||
        locationParts.some((part) => faq.locationId === part.id))
  )
}
